import { inject } from '@angular/core';
import { type CanActivateFn } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';

import { APP_ENV } from '../tokens/app-environment.token';

export const authGuard: CanActivateFn = (_route, state) => {
  const env = inject(APP_ENV);

  if (!env.auth.enabled || !env.auth.clientId) {
    return true;
  }

  return inject(MsalGuard).canActivate(_route, state);
};
